import { customTokens } from "@1js/acui-theme";
import { makeStyles, mergeClasses } from "@fluentui/react-components";

export const useAppFlexMenuStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    listStyleType: "none",
    maxHeight: "504px",
  },
  container: {
    overflow: "hidden auto",
    paddingTop: customTokens.spacingVerticalS,
    // In Safari, the scroll bar does not expand the width of the menu, but covers the items.
    // We need to set a width that is enough to put the scroll bar into.
    width: "367px", // 330 (item) + 2 (border) + 16 (left margin) + 19 (scroll bar width)
    height: "370px",

    "@media screen and (max-height: 256px)": {
      display: "none",
    },
  },
  header: {
    padding: `${customTokens.spacingVerticalXL} ${customTokens.spacingVerticalL} ${customTokens.spacingVerticalM}`,
  },
  footer: {
    height: "71px",
    "& .fui-MenuGroup": {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    "& .fui-MenuItem": {
      minWidth: "unset",
      margin: `${customTokens.spacingHorizontalL} 18px`,
      fontWeight: "bold",
    },
  },
});

export const useAppFlexMenuMaxHeightStyles = makeStyles({
  root: {
    maxHeight: "720px",
  },
});

export const useAppFlexMenuClassName = (expandMaxHeight?: boolean) => {
  const classNames = useAppFlexMenuStyles();
  const classNamesMaxHeight = useAppFlexMenuMaxHeightStyles();
  const rootClassName = expandMaxHeight
    ? mergeClasses(classNames.root, classNamesMaxHeight.root)
    : classNames.root;
  return rootClassName;
};
